'use client'

import { Chip } from '@mui/material'
import { useRouter, useSearchParams } from 'next/navigation'

const FacultyActiveChip = ({ categories = [] }) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const currentQ = searchParams.get('q') || 'all'
  const activeCategory = categories.find((c) => c.slug === currentQ)

  if (!activeCategory) return null

  const handleClear = () => {
    const params = new URLSearchParams(searchParams.toString())
    params.delete('q')
    router.push(`/team/faculty?${params.toString()}`)
  }

  return (
    <div className="tw:flex tw:justify-center tw:mt-2">
      <Chip
        label={activeCategory.label}
        onDelete={handleClear}
        color="primary"
        size="small"
      />
    </div>
  )
}

export default FacultyActiveChip
